<template>
    <div id="tags-view-container" ref="tabWrapRef" class="tags-view-container" :class="{ 'is-white': isWhiteTheme }">
        <scroll-pane ref="scrollPaneRef" class="tags-view-wrapper">
            <router-link v-for="(tag, index) in tabList" ref="tagsRef"
                :to="{ path: tag.path, query: tag.query, params: tag.params, fullPath: tag.fullPath }" exact tag="div"
                draggable="true" @dragstart.native.self="(e:any) => { onDragStart(e, index) }"
                @dragend.native.self="onDragEnd" @dragover.native.prevent="isDragOver = true"
                @dragleave.native.prevent="isDragOver = false" @drop.native="(e:any) => { onDrop(e, index) }"
                :key="tag.fullPath" @contextmenu.prevent.native="openMenu(tag, $event)"
                :class="{ 'active': isActive(tag), 'is-drag-on': (onDragSort && index === dragIndex) }"
                class="tags-view-item">
                <div class="icon-tag-wrap" v-show="isActive(tag)">
                    <div class="left-line">
                        <img v-if="isDefaultTheme" src="./svgs/tab_left_selected-dark.svg" alt="">
                        <img v-if="isWhiteTheme" src="./svgs/tab_left_selected-white.svg" alt="">
                    </div>
                    <div class="center-line actived-tag">
                        <!-- <div class="star-line">
                            <img src="./svgs/tab_icon_selected-dark.svg" alt="">
                        </div> -->
                        <div class="text-title actived-tag">
                            <span>{{ tag.meta.name }}</span>
                        </div>
                        <div class="close-line" v-show="tabList.length > 1"
                            @click.prevent.stop="tabRemove(tag.fullPath)" @dragstart="closeIconNoDrag">
                            <img v-if="isDefaultTheme" src="./svgs/tab_close_selected-dark.svg" alt="">
                            <img v-if="isWhiteTheme" src="./svgs/tab_close_selected-white.svg" alt="">
                        </div>
                    </div>
                    <div class="right-line">
                        <img v-if="isDefaultTheme" src="./svgs/tab_right_selected-dark.svg" alt="">
                        <img v-if="isWhiteTheme" src="./svgs/tab_right_selected-white.svg" alt="">
                    </div>
                </div>
                <div class="icon-tag-wrap" v-show="!isActive(tag)">
                    <div class="left-line">
                        <img v-if="isDefaultTheme" src="./svgs/tab_left_normal-dark.svg" alt="">
                        <img v-if="isWhiteTheme" src="./svgs/tab_left_normal-white.svg" alt="">
                    </div>
                    <div class="center-line">
                        <!-- <div class="star-line">
                            <img src="./svgs/tab_icon-dark.svg" alt="">
                        </div> -->
                        <div class="text-title">
                            <span>{{ tag.meta.name }}</span>
                        </div>
                        <div class="close-line" v-show="tabList.length > 1"
                            @click.prevent.stop="tabRemove(tag.fullPath)" @dragstart="closeIconNoDrag">
                            <img v-if="isDefaultTheme" src="./svgs/tab_close_normal-dark.svg" alt="">
                            <img v-if="isWhiteTheme" src="./svgs/tab_close_normal-white.svg" alt="">
                        </div>
                    </div>
                    <div class="right-line">
                        <img v-if="isDefaultTheme" src="./svgs/tab_right_normal-dark.svg" alt="">
                        <img v-if="isWhiteTheme" src="./svgs/tab_right_normal-white.svg" alt="">
                    </div>
                </div>
            </router-link>
        </scroll-pane>
        <ul v-show="menuVisible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu"
            v-click-outside="clickoutsideCloseMenu">
            <!-- <li @click="refreshSelectedTag(selectedTag)">Refresh</li> -->
            <li v-if="tabList.length > 1" @click="closeCurrentTag">关闭当前页签</li>
            <li @click="closeOthersTags">关闭其他页签</li>
            <li @click="closeRightTags">关闭右侧页签</li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted, onUnmounted, nextTick, provide, toRefs } from 'vue'
import { ClickOutside as vClickOutside, ElMessage } from 'element-plus'
import privateCapabilities from '@cttq/private-capabilities-v3';
import { useRouter, useRoute } from 'vue-router'
import emitter from "@cttq/ui-components-plus-pc/utils/mitt";
// @ts-ignore
import ScrollPane from './ScrollPane.vue'

const router = useRouter()
const route = useRoute()
const emit = defineEmits(['getCurrentTabs'])
const globalState = privateCapabilities.userGlobalState()

const activeTab = ref('')
const menuVisible = ref(false)
const left = ref(0)
const top = ref(0)
const selectedTag = ref<any>({})
const onDragSort = ref(false)
const dragIndex = ref(0)
const fistInitOpenMenu = ref(false)
const oldValue = ref({})
const isDragOver = ref(false)

const tagsRef = ref<any[]>([])
provide('tagList', tagsRef)
const scrollPaneRef = ref()
const tabWrapRef = ref()


type Props = {
    tabList: Array<any>,
    themeType: string
}
const props = withDefaults(defineProps<Props>(), {
    tabList: () => [],
    themeType: 'default'
})

const {tabList} = toRefs(props)

const isWhiteTheme = computed(() => {
    return props.themeType === 'white'
})
const isDefaultTheme = computed(() => {
    return props.themeType === 'default'
})
const isRedTheme = computed(() => {
    return props.themeType === 'red'
})

watch(() => router.currentRoute.value, (newValue:any, oldValue:any) => {
    activeTab.value = newValue.fullPath
    const tabItem = tabList.value.find(item => item.fullPath === newValue.fullPath)
    if (!tabItem) {
        // 根路径不塞
        if (newValue.path !== "/") {
            
            emit('getCurrentTabs', {
                type: 'add',
                item: { ...newValue }
            })
        }
    } else {
        tabItem.fullPath = newValue.fullPath
    }
    if (newValue && newValue.meta && newValue.meta.code) {
        globalState.changeResourceCode(newValue.meta.code)
    }
    if (oldValue) {
        moveToCurrentTag()
        oldValue.value = oldValue
    }
    if (scrollPaneRef.value) {
        scrollPaneRef.value.update()
    }
}, {
    immediate: true,
    deep: true
})


onMounted(() => {
    emitter && emitter.on('removeTabByPath', (fullPath = activeTab.value) => {
        const index = tabList.value.findIndex(item => item.fullPath === fullPath)
        if (index > -1) {
            tabRemove(fullPath)
        } else {
            ElMessage.warning('移除页签失败')
            throw new Error("无法移除对应页签，请检查参数 'fullPath'")
        }
    })
})

onUnmounted(() => {
    emitter && emitter.off('removeTabByPath')
})

const moveToCurrentTag = () => {
    nextTick(() => {
        for (const tag of tagsRef.value) {
            if (tag.to.fullPath === route.fullPath) {
                scrollPaneRef.value.moveToTarget(tag)
                break
            }
        }
    })
}

const tabRemove = (fullPath:any) => {
    if (tabList.value.length <= 1) {
        ElMessage.warning('请至少保留一个页签')
        return
    }
    // 找到删除的标签下标
    const tabIndex = tabList.value.findIndex(item => item.fullPath === fullPath)
    const currentRoute = tabList.value[tabIndex] || { meta: {} }
    // 如果是已选中的
    if (activeTab.value === fullPath) {
        // 找上次标记没有则找下一个标签再没有则找上一个
        const nextTab = currentRoute.meta.hightLightPath ? ({ fullPath: currentRoute.meta.hightLightPath }) : (tabList.value[tabIndex + 1] || tabList.value[tabIndex - 1]);
        // 替换当前路由
        activeTab.value = nextTab.fullPath;
        // 跳转路由
        router.push({ path: nextTab.path, query: nextTab.query })
    }
    // 删除路由列表对应的标签
    const spliceItemArr = tabList.value.splice(tabIndex, 1);
    const spliceItem = spliceItemArr[0] || {}
    emit('getCurrentTabs', {
        type: 'remove',
        item: { ...spliceItem }
    })
}

const isActive = (tag:any) => {
    return activeTab.value === tag.fullPath
}


const gotoFullPath = (tag:any) => {
    if (isActive(tag)) {
        return
    }
    router.push({ path: tag.fullPath })
}



const onDragStart = (e:any, index:number) => {
    e.stopPropagation()
    onDragSort.value = true
    e.dataTransfer.dropEffect = 'move'
    e.dataTransfer.setData('text', index + '')
    dragIndex.value = index
}

// 拖拽结束
// onDragEnd() {
//             this.onDragSort = false
//         },


const onDragEnd = () => {
    onDragSort.value = false
}

const onDrop = (e:any, index:number) => {
    const fromIndex = +e.dataTransfer.getData('text')
    const tabCurrent = tabList.value[fromIndex]
    tabList.value.splice(fromIndex, 1)
    tabList.value.splice(index, 0, tabCurrent)
    isDragOver.value = false
}

const closeIconNoDrag = (e:Event) => {
    e.preventDefault()
}

const openMenu = (tag:any, e:any) => {
    // delay active outside click
    fistInitOpenMenu.value = true
    setTimeout(() => {
        fistInitOpenMenu.value = false
    }, 600)
    const menuMinWidth = 105
    const offsetLeft = tabWrapRef.value.getBoundingClientRect().left // container margin left
    const offsetWidth = tabWrapRef.value.offsetWidth // container width
    const maxLeft = offsetWidth - menuMinWidth // left boundary
    const leftDistance = e.clientX - offsetLeft + 15 // 15: margin right

    if (leftDistance > maxLeft) {
        left.value = maxLeft
    } else {
        left.value = leftDistance
    }

    top.value = e.clientY
    selectedTag.value = tag
    menuVisible.value = true
    
}

const closeCurrentTag = () => {
    tabRemove(selectedTag.value.fullPath)
    menuVisible.value = false
}
const closeOthersTags = () => {
    const tabListCopy = [...tabList.value]
    for (let index = 0; index < tabListCopy.length; index++) {
        const element = tabListCopy[index];
        if (element.fullPath !== selectedTag.value.fullPath) {
            tabRemove(element.fullPath)
        }
    }
    menuVisible.value = false
}
const closeRightTags = () => {
    const tabListCopy = [...tabList.value]
    const currentIndex = tabListCopy.findIndex((element) => element.fullPath === selectedTag.value.fullPath)
    for (let index = 0; index < tabListCopy.length; index++) {
        const element = tabListCopy[index];
        if (index > currentIndex) {
            tabRemove(element.fullPath)
        }
    }
    menuVisible.value = false
}

const clickoutsideCloseMenu = () => {
    if (!fistInitOpenMenu.value) {
        menuVisible.value = false
    }
}
defineOptions({
    name: 'TqPageTabs'
})
</script>